import { ThunkApiType } from 'types/storeTypes';
import authFetch, { checkForUnauthorizedResponse } from '../../utils/axios';

export const getClientsThunk = async (thunkAPI: ThunkApiType) => {
	const getClientsURL = `/clients`;

	try {
		const response = await authFetch.get(getClientsURL);
		return {
			...response.data,
		};
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};
